import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { azureSortedAccountsSelector } from "./azureSortedAccountsSelector";
import { nonDeletedAccountsCombiner } from "../../combiners/nonDeletedAccountsCombiner";

export const azureNonDeletedAccountsSelector = createDraftSafeSelector(
  [azureSortedAccountsSelector],
  nonDeletedAccountsCombiner,
);
